export function openLiveChat(): void {
  if (window.BF_ENABLE_LIVECHAT) {
    try {
      const chatButton: HTMLElement | null =
        document.querySelector('.embeddedMessagingConversationButton')
        || document.querySelector('.helpButtonEnabled');
      if (chatButton) {
        chatButton.click();
        return;
      }
    } catch (e) {
      console.error(e);
    }
  }

  if (BFG.supportWebformUrl) {
    window.open(BFG.supportWebformUrl, '_blank');
  }
}
